export function isTemplate(sectionUrl) {
  return sectionUrl.indexOf('//www.wix.com/') > -1;
}
